<agpr-dialog-container
    id="systemNotificationsCreateDialog"
    [heading]="!notification.id ? 'SystemNotification.createDialog.createNew' : 'SystemNotification.createDialog.edit'"
    (close)="cancel()"
    class="agpr-systemNotificationsCreateDialog"
    [contentPadding]="false"
>
    <agpr-scroll-panel class="agpr-systemNotificationsCreateDialog-content">
        <div>
            <div class="agpr-systemNotificationsCreateDialog-input">
                <!-- Left Panel -->
                <div class="agpr-systemNotificationsCreateDialog-leftPanel">
                    <p class="agpr-systemNotificationsCreateDialog-leftPanel-title"> {{ 'SystemNotification.createDialog.notification.types' | localize }}</p>
                    <ul
                        role="radiogroup"
                        [attr.aria-label]="'SystemNotification.createDialog.notification.types' | localize"
                    >
                        <li
                            *ngFor="let option of options; index as i"
                            class="agpr-systemNotificationsCreateDialog-leftPanel-options"
                        >
                            <agpr-radio
                                id="systemNotificationsCreateDialog.notificationOption"
                                [value]="option"
                                [(ngModel)]="notification.type"
                                (onClick)="handleOptionChange(option)"
                                [hiddenLabel]="option"
                            ></agpr-radio>
                            <agpr-message
                                [severity]="option"
                                [iconStyle]="iconTypes.normal"
                                class="agpr-systemNotificationsCreateDialog-leftPanel-options-option"
                                (click)="handleOptionChange(option)"
                                [hiddenLabel]="option"
                            >
                                {{ option | titlecase }}
                            </agpr-message>
                        </li>
                    </ul>
                    <div class="agpr-systemNotificationsCreateDialog-scheduler">
                        <agpr-delivery-range-scheduler
                            id="systemNotificationsCreateDialog.maintenanceScheduler"
                            [ngClass]="{'agpr-systemNotificationsCreateDialog-scheduler--hidden': notification.type !== notificationTypesEnum.maintenance}"
                            [(ngModel)]="maintenanceTimeRange"
                            (ngModelChange)="maintenanceTimeRangeChanged($event)"
                            [canSelectOngoing]="false"
                        ></agpr-delivery-range-scheduler>
                        <agpr-form-message *ngIf="maintenanceErrors.timeRangeIncomplete">
                            {{ 'SystemNotification.createDialog.error.timeRangeIncomplete' | localize }}
                        </agpr-form-message>
                        <agpr-form-message *ngIf="maintenanceErrors.endDateBeforeStartDate">
                            {{ 'SystemNotification.createDialog.error.endDateLessThanStartDate' | localize }}
                        </agpr-form-message>
                    </div>
                </div>
                <!-- Right Panel -->
                <div class="agpr-systemNotificationsCreateDialog-rightPanel">
                    <div class="agpr-inputGroup">
                        <agpr-text-input
                            [id]="'systemNotificationsCreateDialog.title'"
                            label="SystemNotification.createDialog.title"
                            [maxLength]="64"
                            [placeholder]="'SystemNotification.createDialog.title.placeholder'"
                            [(ngModel)]="notification.title"
                            (ngModelChange)="titleChanged($event)"
                        ></agpr-text-input>
                        <agpr-form-message *ngIf="titleEmpty">
                            {{ 'SystemNotification.createDialog.error.titleEmpty' | localize }}
                        </agpr-form-message>
                    </div>
                    <div class="agpr-inputGroup">
                        <agpr-textarea-input
                            id="systemNotificationsCreateDialog.message"
                            label="SystemNotification.createDialog.message"
                            maxLength="2048"
                            [placeholder]="'SystemNotification.createDialog.message.placeholder'"
                            [(ngModel)]="notification.message"
                            [resize]="resizeDirectionEnum.none"
                        ></agpr-textarea-input>
                    </div>
                    <div class="agpr-systemNotificationsCreateDialog-scheduler--noPadding">
                        <agpr-delivery-range-scheduler
                            id="systemNotificationsCreateDialog.notifScheduler"
                            [(ngModel)]="notificationTimeRange"
                            (ngModelChange)="notificationTimeRangeChanged($event)"
                            [startLabel]="'SystemNotification.createDialog.notification.start'"
                            [endLabel]="'SystemNotification.createDialog.notification.end'"
                            [canSelectOngoing]="false"
                        ></agpr-delivery-range-scheduler>
                        <agpr-form-message *ngIf="notificationErrors.timeRangeIncomplete">
                            {{ 'SystemNotification.createDialog.error.timeRangeIncomplete' | localize }}
                        </agpr-form-message>
                        <agpr-form-message *ngIf="notificationErrors.endDateBeforeStartDate">
                            {{ 'SystemNotification.createDialog.error.endDateLessThanStartDate' | localize }}
                        </agpr-form-message>
                        <agpr-form-message *ngIf="notificationErrors.endDateBeforeMaintenanceEndDate">
                            {{ 'SystemNotification.createDialog.error.endDateBeforeMaintenanceEndDate' | localize }}
                        </agpr-form-message>
                        <agpr-form-message
                            *ngIf="notificationErrors.startDateAfterMaintenanceStartDate"
                        >
                            {{ 'SystemNotification.createDialog.error.startDateAfterMaintenanceStartDate' | localize }}
                        </agpr-form-message>
                    </div>
                </div>
            </div>
        </div>
            <div class="agpr-systemNotificationsCreateDialog-preview">
                <!-- Notification Preview -->
                <p class="agpr-systemNotificationsCreateDialog-preview-title">  {{ 'SystemNotification.createDialog.notification.preview' | localize }}</p>
                <agpr-message
                    class="agpr-systemNotificationsCreateDialog-preview-content"
                    [toggleable]="false"
                    [severity]="notification.type"
                    [isSystemNotification]="true"
                    (updateNotification)="handleNotificationUpdate($event)"
                    [systemNotification]="notification"
                ></agpr-message>
            </div>
    </agpr-scroll-panel>
    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            id="systemNotificationsCreateDialog.cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="systemNotificationsCreateDialog.create"
            [label]="!notification.id? 'SystemNotification.action.create' : 'SystemNotification.createDialog.edit'"
            (click)="create()"
            [style]="buttonTypes.primary"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
